// extracted by mini-css-extract-plugin
export default {"hidden":"TermsOfUse__hidden--p4bI4","container":"TermsOfUse__container--UHox2","termsContainer":"TermsOfUse__termsContainer--unPZ5"};